export default __webpack_public_path__ + "static/media/Coco-about.d20ab925.png";